import { DATABASE_NAME } from "./app.config";

export const localForageConfig: LocalForageOptions = {
  name: DATABASE_NAME,
}
